export default __webpack_public_path__ + "images/TY.336b0e2.png";